
import img2 from './components/image/aVbMoW8_460swp.webp'
import img3 from './components/image/axo1R8Y_460swp.webp'
import img4 from './components/image/img10.jpg'
import icon1 from './components/image/icon1.jpg' 
import icon2 from './components/image/icon2.jpg'
import icon3 from './components/image/icon3.jpg'
import icon4 from './components/image/icon4.jpg'
import icon5 from './components/image/icon5.jpg'
import icon6 from './components/image/icon6.jpg'
import media1 from './components/image/media/media1.jpg'
import media3 from './components/image/media/media3.jpg'
import media5 from './components/image/media/media5.jpg'
import meme1 from './components/image/meme1.jpg'
import meme2 from './components/image/meme2.jpg'
import meme3 from './components/image/meme3.png'
import meme4 from './components/image/meme4.jpg'
import meme5 from './components/image/meme5.png'
import meme6 from './components/image/meme6.jpg'
import meme7 from './components/image/meme7.jpg'
const postData = [
  {
    id: 1,
    title: "🤣🤣🤣🤣🤣🤣🤣🤣🤣",
    op_user: "YamanGhasan",  
    op_user_avatar: icon1, 
    post_time: 1, //yyyy-mm-dd
    up_votes: 100,
    down_votes: 10,
    content: media1,  
    tags: ["java script", "funny"],
    comment_count: 10,
  },
  {
    id: 2,
    title: "How to tell people",
    op_user: "nouralhuda",  
    op_user_avatar: icon2,  
      post_time: 2,  
    up_votes: 200,
    down_votes: 12,
    content: img2,  
    tags: ["school", "world"],
    comment_count: 155,
 
  },
  {
    id: 3,
    title: "many times",
    op_user: "faris",  
    op_user_avatar: icon6,  
      post_time: 8,  
    up_votes: 20,
    down_votes: 12,
    content: img3,  
    tags: ["football", "cozy" ],
    comment_count: 50,
 
  },
  {
    id: 4,
    title: "lol",
    op_user: "lojain",  
    op_user_avatar: icon1,  
      post_time: 9,  
    up_votes: 230,
    down_votes: 172,
    content: img4,  
    tags: ["school", "project"],
    comment_count: 190,
 
  },
  {
    id: 5,
    title: "hahahahah",
    op_user: "Ibrahem", 
    op_user_avatar: icon2, 
      post_time: 10, 
    up_votes: 200,
    down_votes: 12,
    content: media3,  
    tags: ["programming", "code"],
    comment_count: 155,
  }
  ,
  {
    id: 6,
    title: "whyyyyy",
    op_user: "gager", 
    op_user_avatar: icon3,  
      post_time: 11, 
    up_votes: 200,
    down_votes: 12,
    content: meme3, 
    tags: ["parent", "home"],
    comment_count: 155,
  } 
  ,
   {
    id: 7,
    title: "every time",
    op_user: "Ibrahim Khdeir ", 
    op_user_avatar: icon5,  
      post_time: 5, 
    up_votes: 200,
    down_votes: 12,
    content: media5,  
    tags: ["funny", "final"],
    comment_count: 155,
  } ,
   {
    id: 8,
    title: "lol",
    op_user: "Yaman " ,
    op_user_avatar: icon3,  
      post_time: 23,  
    up_votes: 200,
    down_votes: 12,
    content: meme1,  
    tags: ["world", "lol"],
    comment_count: 155,
  }
  , 
   {
    id: 9,
    title: "How to tell people",
    op_user: "raghad ", 
    op_user_avatar: icon2,  
      post_time: 15, 
    up_votes: 200,
    down_votes: 12,
    content: meme2,  
    tags: ["palestine", "final"],
    comment_count: 155,
  },
  {
    id: 10,
    title: "really !!!",
    op_user: "basil", 
    op_user_avatar: icon4,  
      post_time: 15, 
    up_votes: 200,
    down_votes: 12,
    content: meme4, 
    tags: ["music", "fun"],
    comment_count: 155,
  },
  {
    id: 11,
    title: " !!!",
    op_user: "gagername", 
    op_user_avatar: icon5,  
      post_time: 15, 
    up_votes: 22,
    down_votes: 12,
    content: meme5, 
    tags: ["lol", "fun"],
    comment_count: 53,
  },
  {
    id: 12,
    title: " hhahahahah",
    op_user: "nour", 
    op_user_avatar: icon3,  
      post_time: 15, 
    up_votes: 22,
    down_votes: 12,
    content: meme6, 
    tags: ["money", "funny"],
    comment_count: 53,
  }
  ,
  {
    id: 13,
    title: "uhh",
    op_user: "faris", 
    op_user_avatar: icon2,  
      post_time: 33, 
    up_votes: 22,
    down_votes: 12,
    content: meme7, 
    tags: ["money", "life"],
    comment_count: 53,
  }

];
  

 export default postData;